import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {withStyles} from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import {lighten} from '@material-ui/core/styles/colorManipulator';
import {Card, CardBody, Col, Button, ButtonGroup, Row, Badge} from 'reactstrap';
import arrayToCsv from "../../../modules/arrayToCsv";
import * as TextManager from "../../../modules/languages/TextManager";
import FirstPageIcon from '@material-ui/icons/FirstPage';
import LastPageIcon from '@material-ui/icons/LastPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import 'react-circular-progressbar/dist/styles.css';

let counter = 0;

function createData(id_n, name, calories, fat, carbs, protein) {
    counter += 1;
    return {id: counter, id_n, name, calories, fat, carbs, protein};
}

function desc(a, b, orderBy) {
    if(a[orderBy] === null) {
        return 1;
    }
    if(b[orderBy] === null) {
        return -1;
    }
    //alert(typeof a);
    if (typeof a[orderBy] === 'string') {
        // string can contains number
        let isNumber = /^\d*\.?\d+$/.test(a[orderBy]);
        if (isNumber) {
            if (parseInt(b[orderBy]) < parseInt(a[orderBy])) {
                return -1;
            }
            if (parseInt(b[orderBy]) > parseInt(a[orderBy])) {
                return 1;
            }
            return 0;
        }
        else {

            if (b[orderBy].toUpperCase() < a[orderBy].toUpperCase()) {
                return -1;
            }
            if (b[orderBy].toUpperCase() > a[orderBy].toUpperCase()) {
                return 1;
            }
            return 0;
        }
    }
    else {

        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }
}

function stableSort(array, order, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return order === 'asc' ? a[1] - b[1] : b[1] - a[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
    '@media screen and (max-width: 480px)': {
        root: {
            marginLeft: '0px'
        }
    }
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const {classes, count, page, rowsPerPage, theme} = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon/> : <FirstPageIcon/>}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight/> : <KeyboardArrowLeft/>}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft/> : <KeyboardArrowRight/>}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon/> : <LastPageIcon/>}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, {withTheme: true})(
    TablePaginationActions,
);


class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {onSelectAllClick, order, orderBy, numSelected, rowCount, rows} = this.props;

        return (
            <TableHead>
                <TableRow>

                    {rows.map(row => {
                        return (
                            <TableCell
                                style={{textAlign: 'right'}}
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? 'none' : 'default'}
                                sortDirection={orderBy === row.id ? order : false}
                            >
                                <Tooltip
                                    title={TextManager.getCurrentTextResource().Utils.sort}
                                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing.unit,
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',
    },
});

let EnhancedTableToolbar = props => {
    const {numSelected, classes} = props;

    return (
        <Toolbar
            className={classNames(classes.root, {
                [classes.highlight]: numSelected > 0,
            })}
        >
            <div className={classes.title}>
                {numSelected > 0 ? (
                    <Typography color="inherit" variant="subtitle1">
                        {numSelected} selected
                    </Typography>
                ) : (
                    <Typography variant="h6" id="tableTitle">
                        Nutrition
                    </Typography>
                )}
            </div>
            <div className={classes.spacer}/>
            <div className={classes.actions}>
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Filter list">
                        <IconButton aria-label="Filter list">
                            <FilterListIcon/>
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

EnhancedTableToolbar.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    table: {
        minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    }
});

const CustomPagination = withStyles(theme => ({
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-45px'
        }
    }

}))(TablePagination);


const customColumnStyle = {
    wordWrap: "break-word",
    maxWidth: "1px"
};

class EnhancedTable extends React.Component {
    state = {
        order: 'asc',
        orderBy: 'calories',
        selected: [],
        //data: this.initializeData(),
        page: 0,
        rowsPerPage: 15,
        symbol: this.loadCurrencySymbol()
    };

    initializeData() {

        var copyData = [];

        this.props.data.map((rowData, index) => {

            let object = rowData;
            object['id_n'] = index;
            copyData.push(object);
        });

        return copyData;
    };

    loadCurrencySymbol() {
        /*let all = require('../../../modules/languages/currency_symbols.json');
        let region = TextManager.getCurrentRegion();
        return all.find(e => e.region === region).symbol;*/
        return '';
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({order, orderBy});
    };

    handleSelectAllClick = event => {
        if (event.target.checked) {
            this.setState(state => ({selected: state.data.map(n => n.id)}));
            return;
        }
        this.setState({selected: []});
    };

    handleClick = (event, id) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    handleDownload = () => {
        /*let data = this.props.data;

        if (data.length > 0) {
            let filterNames = Object.getOwnPropertyNames(data[0]);

            for (let indx in data) {
                for (let indx2 in filterNames) {

                    if (filterNames[indx2] === 'deals') {
                        data[indx][filterNames[indx2]] = this.buildDealsString(data[indx].deals).join(';');
                    }
                    else {
                        data[indx][filterNames[indx2]] = this.addingCurrency(filterNames[indx2]) + data[indx][filterNames[indx2]]
                    }
                }
            }

            let fileDownload = require('js-file-download');
            fileDownload(arrayToCsv({data}), 'download.csv');
        }*/

        let data = this.props.data;

        if(data.length > 0 ) {
            let filterNames = Object.getOwnPropertyNames(data[0]);
            if (filterNames.includes('deals')) {
                for (let indx in data) {
                    data[indx].deals = this.buildDealsString(data[indx].deals).join(';');
                }
            }

            let fileDownload = require('js-file-download');
            fileDownload(arrayToCsv({data}), 'download.csv');
        }
    };

    buildDealsString(deals) {
        let symbol = this.state.symbol;
        let resDeals = [];

        let countries = [];
        if (this.props.utilsData.data && this.props.utilsData.data.countries.length > 0) {
            countries = this.props.utilsData.data.countries;
        }

        let products = [];
        if (this.props.utilsData.data && this.props.utilsData.data.products.length > 0) {
            products = this.props.utilsData.data.products;
        }

        let platforms = [];
        if (this.props.utilsData.data && this.props.utilsData.data.platforms.length > 0) {
            platforms = this.props.utilsData.data.platforms;
        }

        if (deals.length > 0) {
            let filterNames = Object.getOwnPropertyNames(deals[0]);

            for (let indx in deals) {
                let str = "";
                for (let indx2 in filterNames) {
                    let col = filterNames[indx2];
                    if (deals[indx][col] !== "") {
                        if (col === 'country') {
                            if (deals[indx][col] !== '0') {
                                str += countries.find(e => e.key === deals[indx][col]).value + " ";
                            }
                        }
                        else if (col === 'product') {
                            for (let indx3 in deals[indx][col]) {
                                if (deals[indx][col][indx3] !== '0') {
                                    str += products.find(e => e.key === deals[indx][col][indx3]).value + " ";
                                }
                            }

                            //str += products.find(e => e.key === deals[indx][col]).value + " ";
                        }
                        else if (col === 'platform') {
                            if (deals[indx][col] !== '0') {
                                str += platforms.find(e => e.key === deals[indx][col]).value + " ";
                            }
                        }
                        else if (col === 'ranges') {
                            for (let indx3 in deals[indx][col]) {
                                if (deals[indx][col][indx3].from !== "0" && deals[indx][col][indx3].to !== "0" && deals[indx][col][indx3].payout !== "0") {
                                    str += "Tier From: " + deals[indx][col][indx3].from + ", To: " + deals[indx][col][indx3].to + ", Payuot: " + deals[indx][col][indx3].payout;
                                }
                            }
                        }
                        else if (col === 'useForOld' || col === 'carryOver') {
                            if (col === 'carryOver' && deals[indx][col] === false) {
                                str += col + ": " + deals[indx][col] + " ";
                            }
                        }
                        else if (col === 'paymentType') {
                            let type = deals[indx][col];
                            if (type === 'CPA' || type === 'Flat fee/Bonus') {
                                str += deals[indx][col] + " " + symbol;
                            }
                            else {
                                str += deals[indx][col] + " %";
                            }
                        }
                        else if (col === 'baseline') {
                            str += "Baseline: " + symbol + deals[indx][col] + " ";
                        }
                        else {
                            if (deals[indx][col] !== null) {
                                str += deals[indx][col] + " ";
                            }
                        }
                    }
                }

                if (str !== "") {
                    //resDeals.push(str + String.fromCharCode(13));
                    resDeals.push(str);
                }
            }
        }

        return resDeals;
    }

    ifCurrency = (item) => {
        if (item === 'bonus' || item === 'cpaCommission' || item === 'depositsTotal' || item === 'firstDeposit' ||
            item === 'revCommission' || item === 'deposit_amount' || item === 'depositsAmount' || item === 'flatCommission' ||
            item === 'totalCommission' || item === 'grossRev' || item === 'netRev' || item === 'depositTotalAmount' || item === 'depositAmount' ||
            item === 'avgDeposit' || item === 'avgFtdDeposit' || item === 'ggr' || item === 'ngr' || item === 'cost' || item === 'avgGgr' || item === 'avgNgr') {
            return true;
        }
        else {
            return false;
        }
    };

    ifNumber = (item) => {
        if(item === 'depositsCnt' || item === 'signups' || item === 'ftds' || item === 'clicks' || item === 'registrations' || item === 'ftd' ||
           item === 'valid_ftd' || item === 'deposit_count' || item === 'affiliate_id') {
            return true;
        }
        else{
            return false;
        }
    };

    addingCurrency = (item) => {
        let res = "";
        let symbol = this.state.symbol;
        if (this.ifCurrency(item)) {
            res = symbol;
        }

        return res;
    };

    /*getCustomComponent = (item, value) => {

        switch (item) {
            case 'nonReturnedPercent':
            case 'vipPercent':
            case 'regularPercent':
                return <div style={{width: "55px", height: '55px', padding: '6px'}}>
                    <CircularProgressbar
                        initialAnimation
                        percentage={value}
                        text={`${value}%`}
                        styles={{
                            path: {
                                stroke: circleRateColors.find(e => e.key === item).color,
                                // Customize transition animation
                                transition: 'stroke-dashoffset 2s ease 0s',
                            },
                            text: {
                                // Text color
                                fill: '#555555',
                                // Text size
                                fontSize: '27px',
                                fontWeight: 'bold'
                            },
                        }}
                    />
                </div>;

            default:
                return <span></span>
        }

    };*/

    commafy = (item, num) => {
        if (this.ifCurrency(item)) {
            let str = num.toString().split('.');
            if (str[0].length >= 5) {
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
            /*if (str[1] && str[1].length >= 5) {
                str[1] = str[1].replace(/(\d{3})/g, '$1 ');
            }
            return str.join('.');*/
            return str[0];
        }
        else if(this.ifNumber(item)) {
            let str = num.toString().split('.');
            if (str[0].length >= 4) {
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
            }
            return str[0];
        }
        else {
            return num;
        }
    };


    render() {
        const {classes} = this.props;
        //const {data, order, orderBy, selected, rowsPerPage, page} = this.state;
        //const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

        const {order, orderBy, selected, rowsPerPage, page} = this.state;
        let data = this.initializeData();

        let countries = [];
        if (this.props.utilsData.data && this.props.utilsData.data.countries && this.props.utilsData.data.countries.length > 0) {
            countries = this.props.utilsData.data.countries;
        }

        return (
            <Col md={12} xl={12} lg={12} xs={12} style={this.props.noPaddingCard ? {paddingLeft: '0px', paddingRight: '0px'} : {}}>
                <Card>
                    <CardBody>
                        {/*<EnhancedTableToolbar numSelected={selected.length}/>*/}
                        {this.props.meta.name !== "" &&
                        <div className="card__title">
                            <h5 className="bold-text">{this.props.meta.name}</h5>
                        </div>
                        }
                        <div className={classes.tableWrapper}>
                            <Table className={classes.table} aria-labelledby="tableTitle">
                                <EnhancedTableHead
                                    numSelected={selected.length}
                                    order={order}
                                    orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={data.length}
                                    rows={this.props.meta.metrics}
                                />
                                <TableBody>
                                    {stableSort(data, order, getSorting(order, orderBy))
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map(n => {
                                            const isSelected = this.isSelected(n.id_n);
                                            return (
                                                <TableRow
                                                    hover
                                                    onClick={event => this.handleClick(event, n.id_n)}
                                                    aria-checked={isSelected}
                                                    tabIndex={-1}
                                                    key={n.id_n}
                                                    selected={isSelected}
                                                >

                                                    {this.props.meta.metrics.map((el, index) => {
                                                        let val = n[el.id];
                                                        if (el.id === 'playerCountry') {
                                                            let obj = countries.find(e => e.key === val);
                                                            if (obj !== undefined) {
                                                                val = obj.value;
                                                            }
                                                            else {
                                                                val = '';
                                                            }
                                                        }
                                                        else if (el.id === 'deals') {
                                                            val = this.buildDealsString(n[el.id]).map((item, index) =>
                                                                <p key={index}>{item}</p>
                                                            )
                                                        }
                                                        else {
                                                            val = this.addingCurrency(el.id) + val;
                                                        }
                                                        ///////////////////////////////

                                                        if (this.props.customFields && this.props.customFields.includes(el.id)) {
                                                            return <TableCell key={index} component="th" scope="row" style={{textAlign: 'right'}}
                                                                              padding="none">
                                                                {this.props.getCustomComponent(el.id, val)}
                                                            </TableCell>
                                                        }
                                                        else {
                                                            if (el.numeric) {
                                                                return <TableCell key={index} numeric style={{textAlign: 'right'}}>{this.commafy(el.id, val)}</TableCell>
                                                            }
                                                            else {
                                                                return <TableCell key={index} component="th" scope="row" style={this.props.breakLine ? customColumnStyle : {}}
                                                                                  padding="none" style={{textAlign: 'right'}}>{this.commafy(el.id, val)}</TableCell>
                                                            }
                                                        }
                                                    })}

                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </div>
                        {this.props.download ?
                            <Row>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <ButtonGroup className='btn-group--icons'
                                                 style={{marginTop: "10px", float: "left"}}>
                                        <Button outline color='primary'
                                                onClick={this.handleDownload}>{TextManager.getCurrentTextResource().Utils.download}</Button>
                                    </ButtonGroup>
                                </Col>
                                <Col md={6} sm={12} lg={6} xs={12}>
                                    <CustomPagination
                                        labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                        rowsPerPageOptions={[5, 15, 25]}
                                        component="div"
                                        count={data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        ActionsComponent={TablePaginationActionsWrapped}
                                    />
                                </Col>
                            </Row> : this.props.noPagination ?
                                <span></span> :
                                <CustomPagination
                                    labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                    rowsPerPageOptions={[5, 15, 25]}
                                    component="div"
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActionsWrapped}
                                />
                        }

                    </CardBody>
                </Card>
            </Col>
        );
    }
}

EnhancedTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        utilsData: state.utilsData
    };
};

//export default withStyles(styles)(EnhancedTable);

// compose - to put all together
export default compose(
    withStyles(styles),
    withRouter,
    connect(mapStateToProps))(EnhancedTable);